module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: ("col-sm-" + (_vm.getColumn()) + " items-col")
  }, [_c('draggable', {
    attrs: {
      "group": "hooks",
      "draggable": ".draggable"
    },
    model: {
      value: (_vm.computedHooks),
      callback: function($$v) {
        _vm.computedHooks = $$v
      },
      expression: "computedHooks"
    }
  }, [_vm._l((_vm.computedHooks), function(question) {
    return _c('div', {
      key: question.id,
      staticClass: "hook-item draggable"
    }, [_c('hook-media', {
      attrs: {
        "hook": question.mediaClip
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "options pull-right"
    }, [_c('el-tooltip', {
      attrs: {
        "content": "Remove"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-trash",
      on: {
        "click": function($event) {
          return _vm.handleRemoveHook(question.id)
        }
      }
    })])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "placeholder-container hook-placeholder-container"
  }, [_vm._v("Drag hook")])])], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "65px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.computedIsRandomized),
      callback: function($$v) {
        _vm.computedIsRandomized = $$v
      },
      expression: "computedIsRandomized"
    }
  }, [_vm._v("Present in random order")])], 1)], 1), _vm._v(" "), (_vm.computedHooks.length) ? _c('div', {
    staticClass: "col-sm-8 items-col"
  }, [_c('draggable', {
    attrs: {
      "group": "music-questions",
      "draggable": ".draggable"
    },
    model: {
      value: (_vm.computedMatrixChoices),
      callback: function($$v) {
        _vm.computedMatrixChoices = $$v
      },
      expression: "computedMatrixChoices"
    }
  }, [_vm._l((_vm.computedMatrixChoices), function(matrixChoice) {
    return _c('div', {
      key: matrixChoice.title,
      staticClass: "question-item draggable"
    }, [_c('div', [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(matrixChoice.title))]), _vm._v(" "), _vm._l((matrixChoice.choices), function(choice) {
      return _c('div', {
        key: choice.id,
        staticClass: "choice"
      }, [_vm._v(_vm._s(choice.title))])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "options pull-right"
    }, [(_vm.computedMatrixChoices.length > 1) ? _c('span', [_c('el-tooltip', {
      attrs: {
        "content": "Conditional"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-link",
      class: {
        'has-conditional': _vm.isConditional(matrixChoice)
      },
      on: {
        "click": function($event) {
          return _vm.handleSetConditional(matrixChoice)
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "tool-divider"
    })], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": "Remove"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-trash",
      on: {
        "click": function($event) {
          return _vm.handleRemoveMatrixChoice(matrixChoice.id)
        }
      }
    })])], 1)])
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "placeholder-container media-question-placeholder-container"
  }, [_vm._v("Drag media question")])])], 2)], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b919cd8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/editors/music/MusicEditorExpanded.vue
// module id = 3231
// module chunks = 3